/**
 * @desc 保存
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductBrandResponseDto>;
export function request(
  body: defs.basics.ProductBrandRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productBrand/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
